
<template>
  <div class="toolTip-box">
    <div class="conttent">
      <h2 class="title">Wi-Fi配置成功</h2>
      <p class="tip-text"> Wi-Fi配置成功，设备正在联网更新数据, 此过程需要一些时间，请耐心等候</p>
      <div class="pic" :style="{backgroundImage: 'url('+imgSrc+')'}"></div>
      <div class="btn-box">
          <button class="btn no f-l" @click="cancel()">我知道了</button>
      </div>
    </div>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
var _local = window.location.href
export default {
  data () {
    return {
      imgSrc: Common.staticHref() + 'img/wifiSuccess.png',
      fromPage: this.$route.query.pageName
    }
  },
  methods: {
    cancel () {
      if (this.fromPage === 'Main') {
        sessionStorage.removeItem('isfirst')
        window.location.replace(_local.split('?')[0])
      } else {
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  .conttent
    background #ffffff
    width 343px
    padding 21px 0
    border-radius 10px
    colmCenter()
    .title
      font-size 16px
      line-height 35px
      color #333333
    .tip-text
      width 233px
      font-size 14px
      color #282828
      line-height 24px
      margin 0 auto 
    .pic
      width 166px
      height 135px
      margin 0 auto
      background-repeat no-repeat
      background-position center center
      background-size contain
    .btn-box
      margin 0 auto
      width 135px
      height 40px
      .btn
        width 135px
        height 40px
        text-align center
        background #ededed
        color #ffffff
        font-size 17px
        border-radius 20px
        margin-top 10px
      .no
        color #666666
      .yes
        color #0f95e1

</style>


// WEBPACK FOOTER //
// src/pages/wifiSuccess/wifiSuccess.vue